import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import store, { applicationActions } from '@apply/adminStore';
import { useSelector } from 'react-redux';
import { ApplicationApi } from '@apply/api';
import { applicationInsights } from '../../../ApplicationInsights';
import { LoadPanel } from 'devextreme-react/load-panel';
import { ModalSummaryHeader } from '../../common/ApplicationComponents';

const ApplicationSummaryModal = () => {
    const { isOpen, id } = useSelector((state) => state.application.applicationSummaryModal);
    const { dispatch } = store;
    const applicationApi = new ApplicationApi.ApplicationApi(applicationInsights);
    const [application, set_application] = useState(null);
    const [loadingOpen, set_loadingOpen] = useState(false);
    const [loadingMessage] = useState('Loading...');

    const reviewStyles = {
        buttonContainer: { marginRight: '20px', textAlign: 'right' },
    };

    useEffect(() => {
        if (!id) {
            resetState();
            return;
        }

        const loadAppAsync = async () => {
            await loadApplication(id);
        };
        loadAppAsync();
    }, [id]);

    const resetState = () => {
        set_application(null);
    };

    const _handleClose = () => {
        dispatch(
            applicationActions.setApplicationSummaryModal({
                applicationSummaryModal: { isOpen: false },
            })
        );
    };

    const loadApplication = async (id) => {
        try {
            set_loadingOpen(true);
            const review = (await applicationApi.getApplicationSummary(id)).result;
            if (!review) {
                return;
            }

            set_application(review);
        } finally {
            set_loadingOpen(false);
        }
    };

    if (!application) {
        return null;
    }

    return (
        <>
            <Dialog
                maxWidth='sm'
                open={isOpen}
                onClose={_handleClose}
                aria-labelledby='form-dialog-title'
            >
                <DialogContent>
                    <div className='modal-container'>
                        <div className='modal-backdrop'></div>
                        <div
                            className='modal'
                            tabIndex='-1'
                            role='dialog'
                            style={{ width: '800px' }}
                        >
                            <div
                                className='modal-dialog'
                                role='document'
                            >
                                <div>
                                    <div
                                        className='page-header'
                                        role='banner'
                                    >
                                        <h1>Application Summary</h1>
                                        <button
                                            type='button'
                                            className='close'
                                            data-dismiss='modal'
                                            aria-label='Close'
                                            onClick={_handleClose}
                                        >
                                            <span aria-hidden='true'>&times;</span>
                                        </button>
                                    </div>
                                    <ModalSummaryHeader
                                        application={application}
                                        expandReasons={true}
                                    />
                                    <div className='row'>
                                        <div className='columns small-12 large-12'>
                                            <h2 className='decorated'>Properties</h2>
                                            <ul>
                                                {(!application.properties || application.properties.length === 0) && (
                                                    <li>No Properties found!</li>
                                                )}
                                                {application.properties &&
                                                    application.properties.length > 0 &&
                                                    application.properties.map((p) => {
                                                        return (
                                                            <li key={'p' + p.id}>
                                                                {p.street1} {p.street2}, {p.city} {p.state}, {p.zipCode}
                                                            </li>
                                                        );
                                                    })}
                                            </ul>
                                        </div>
                                    </div>
                                    <form name='propertyReviewForm'>
                                        <div
                                            className='button-footer'
                                            style={reviewStyles.buttonContainer}
                                        >
                                            <button
                                                type='button'
                                                className='button hollow'
                                                data-dismiss='modal'
                                                onClick={_handleClose}
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
            <LoadPanel
                hideOnOutsideClick={false}
                visible={loadingOpen}
                message={loadingMessage}
            />
        </>
    );
};

export default ApplicationSummaryModal;
